export const SPECIAL_COLLECTIONS_MARKETS = [
  '785cJ8J2CL1WL9NVDhMUXm4Q1CC8dXDytpSap5DPTa2J',
  '9VYeTs4iwCv7TVHxrNuUC5t6Yz1xhWeBHbFgNsx9u7rP',
  '7hZYBSfxVJEydFxzugnthKJn8f2Xq3Hh44Noi6rXqUF8',
  'CPca2BSabUFiP8ioanSSEWVUY5QzND6wKxiWAPi98Yc4',
  'Bkv2jmAQDqJPWogsRxZD2eD7TenJtYwQUprMoYgPyLB7',
  'DJ93XkwUQXipHEpNCf8esEZf2mPh1NFhqLoYMnHL1Baw',
  '4Z4L87vE7mwxSa4tYvmXKEF5swbkoEg4RfosFh1nyw1W',
  'BKTH6dKm3WTwYAr9PxKSEgPfHScqxtMqgfD8kuZ2QPm',
  '3eF8HfdCFJyAo59zgojh8JqpXAWPYoBZtHeN4p5kbjLy',
  '5Sv82y2nhQcfGDFeM88h92RcVFht4TmqRxXxB5BDUYKD',
  'GRNHQ8Nc1xQzFsdSPac8C3ebvUH9f7AaLMnjG2y2DxUh',
  'Eow8QKUgXjimLaJidbHpZTCsp4NxxVZ9U5nwEH3PTb81',
]
